import axiosClient from './setup/axiosClient';

export const EinvoiceHistoryApis = {
  getEinvoiceSendHistory: async (params: any): Promise<any> => {
    return axiosClient.get('/sap/einvoice-send-history', { params });
  },

  resendEinvoice: async (data: any): Promise<any> => {
    return axiosClient.post('/sap/resend-einvoice', data);
  },

  getEinvoiceResendQuota: async (soCode: string): Promise<any> => {
    return axiosClient.get(`/sap/einvoice-resend-quota/${soCode}`);
  },

  getDistinctInvoiceSerials: async (): Promise<any> => {
    return axiosClient.get('/sap/einvoice-serials');
  },
};
